import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private themeClassPrefix = 'theme-';

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  applyTheme(themeName: string): void {
    const body = document.body;

    // Remover clases anteriores
    Array.from(body.classList).forEach((cls) => {
      if (cls.startsWith(this.themeClassPrefix)) {
        this.renderer.removeClass(body, cls);
      }
    });

    // Aplicar nuevo tema
    const newThemeClass = this.themeClassPrefix + themeName;
    this.renderer.addClass(body, newThemeClass);
    localStorage.setItem('tema', themeName);
  }

  cargarTemaDesdeStorage(): void {
    const tema = localStorage.getItem('tema') || 'zivo'; // Valor por defecto
    this.applyTheme(tema);
  }
}
